import { MapPin, ArrowUpRight } from "lucide-react";
import { SITE } from "../lib/site";

export default function MapBlock({ tall = false }) {
  return (
    <div data-testid="map-block" className="relative overflow-hidden rounded-[28px] border border-navy/10 bg-navy">
      <iframe
        title="MHM SUPER ADBLUE location — Haldia, West Bengal"
        src={SITE.mapEmbed}
        loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"
        className={`w-full grayscale-[0.4] contrast-[1.05] ${tall ? "h-[460px]" : "h-[380px]"}`}
      />
      <div className="absolute bottom-4 left-4 right-4 flex flex-col gap-3 rounded-2xl bg-navy/90 p-5 text-white backdrop-blur-md sm:flex-row sm:items-center sm:justify-between">
        <p className="flex items-start gap-3 text-sm">
          <MapPin className="h-5 w-5 shrink-0 text-brand" /> {SITE.location}
        </p>
        <a
          href={SITE.mapLink}
          target="_blank"
          rel="noreferrer"
          data-testid="map-directions-link"
          className="inline-flex items-center gap-1.5 whitespace-nowrap text-sm font-semibold text-brand hover:text-white"
        >
          Get directions <ArrowUpRight className="h-4 w-4" />
        </a>
      </div>
    </div>
  );
}
